import { call } from "redux-saga/effects";

import { backOfficeApiService } from "../../../../actionService/apiService";

import endPoints from "./leads.endpoints";

import { CreateLeadRequestDto, FilterLeadsRequestDto, UpdateLeadDto } from "./leads.requestsDto";

import { ApiCallResult } from "../../../../types";

import LeadDto from "../../../../../dto/Lead/LeadDto";

const backOfficeLeadsApi = {
  create: function* (dto: CreateLeadRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Post], endPoints.controller, dto)) as ApiCallResult<LeadDto>;
  },

  filter: function* (dto: FilterLeadsRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Get], endPoints.filter, undefined, dto)) as ApiCallResult<{
      data: Array<LeadDto>;
      total: number;
    }>;
  },

  getById: function* (id: number) {
    return (yield call([backOfficeApiService, backOfficeApiService.Get], endPoints.controller, id)) as ApiCallResult<LeadDto>;
  },

  update: function* (id: number, dto: UpdateLeadDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Put], endPoints.controller, id, dto)) as ApiCallResult<LeadDto>;
  },
};

export default backOfficeLeadsApi;
